module.exports = __webpack_public_path__ + "static/media/Declaracao_de_consentimento_de_dados_pessoais_TASTEPORTUGAL.14619622.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/Declaracao_de_consentimento_de_dados_pessoais_TASTEPORTUGAL.pdf
// module id = 824
// module chunks = 0